import { Component, OnInit } from '@angular/core'

import { BreadcrumbLink } from '../../shared/interfaces/resources/breadcrumb-link.interface'
import { BreadcrumbService } from '../../shared/services/breadcrumb.service'

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbLinks: BreadcrumbLink[]

  constructor(private breadcrumbService: BreadcrumbService) {}

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbLinks.subscribe({
      next: (newBreadcrumbLinks: BreadcrumbLink[]) => {
        this.breadcrumbLinks = newBreadcrumbLinks
      }
    })
  }
}
